import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        '@media (max-width: 1430px)': { width: 'fit-content' }
    },
    currencyContainer: {
        marginLeft: 'calc(25% + 1.5rem);',
        marginTop: '-20px'
    },
    currencyDropdownTitle: {
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        fontSize: '0.9rem',
        fontWeight: 700,
        fontFamily: 'client-font,sans-serif'
    },
    currencyDropdown: {
        flexGrow: 1,
        marginLeft: '0.5rem'
    },
    firmWalletSelectContainer: { padding: '0 1.5rem' },
    firmSelectContainer: {
        marginRight: '1.5rem',
        marginBottom: '1rem'
    },
    firmSelect: {
        borderTop: `2px solid ${theme?.app?.clientTheme.colors.primaryColorLight ||
        '#009BDF'}`,
        borderRadius: '4px'
    },
    transactionGridContainer: {
        borderTop: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#cfcfcf'}`,
        flexGrow: 1
    },
    dateRangeSelectorContainer: { marginRight: '2rem' },
    filterOption: {
        padding: '.3rem .75rem',
        fontSize: '.8rem',
        textTransform: 'uppercase' as const,
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        cursor: 'pointer' as const,
        borderRight: '1px solid #d3d3d3',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHoverLight ||
                '#bec6d470'
        }
    },
    lastFilterOption: {
        borderRight: 'none' as const,
        marginRight: '2rem'
    },
    selectedFilterOption: {
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        color: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.primaryColor ||
                '#375073'
        }
    },
    clearFiltersButton: {
        padding: '.3rem',
        fontSize: '.8rem',
        fontWeight: 'bold' as const,
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        marginLeft: '.75rem',
        cursor: 'pointer' as const,
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHoverLight ||
                '#009BDF'
        }
    },
    realtimeTag: {
        fontSize: '.8rem',
        marginReft: '2rem'
    },
    realtimeState: {
        padding: '.4rem',
        marginLeft: '.6rem',
        borderRadius: '3px',
        fontWeight: 'bold' as const
    },
    realtimeEnabled: {
        color: theme?.app?.applicationColors.successDark ||
            '#5AAC01',
        backgroundColor: theme?.app?.applicationColors.successOpaque ||
            '#5AAC011A'
    },
    realtimeDisabled: {
        color: theme?.app?.applicationColors.failure ||
            '#FA5252',
        backgroundColor: theme?.app?.applicationColors.failureOpaque ||
            '#FA52521A'
    },
    exportContainer: {
        width: 'auto' as const,
        minWidth: '15rem',
        paddingRight: '1rem'
    },
    exportIcon: {
        height: '16px',
        width: '24px'
    },
    selectedFilter: {
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        color: theme?.app?.applicationColors.enumColors.white ||
            '#FFFFFF'
    },
    pageSelectorContainer: { padding: '0 1.5rem 1rem 1.5rem' },
    tassatPayLogo: {
        width: '8.5rem',
        alignSelf: 'flex-end'
    }
});